import ErrorModal from 'components/ErrorModal/ErrorModal';
import Header from 'components/Header/Header';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import store from './store';
import { createBrowserHistory } from 'history';
import { ErrorBoundary } from '@pec/aion-ui-core/components/ErrorBoundary';
import { Feature } from 'flagged';
import { FeatureFlagWrapper } from '@pec/aion-ui-core/features/featureFlags/components/FeatureFlagWrapper';
import { getTrackingId } from 'helpers/getTrackingId';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { Routes } from 'routes/Routes';
import { Theme } from '@pec/aion-ui-components/components/Theme';

ReactGA.initialize(getTrackingId(), {
  debug: process.env.NODE_ENV === 'development',
  testMode: process.env.NODE_ENV === 'test'
});

export const App: React.FC = () => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <ErrorModal />
        <Header />
        <FeatureFlagWrapper>
          <Feature name="AionBillingUi">
            <Router history={createBrowserHistory({ basename: '/billing' })}>
              <Theme>
                <Routes />
              </Theme>
            </Router>
          </Feature>
        </FeatureFlagWrapper>
      </Provider>
    </ErrorBoundary>
  );
};
